import { Socket } from 'socket.io-client'

export default class CreditSocket {
  private socket: Socket

  constructor(socket: Socket) {
    this.socket = socket
  }

  onCreditAllocated(callback: (data: any) => void): void {
    this.socket.on('credit_allocated', callback)
  }

  onCreditRevoked(callback: (data: any) => void): void {
    this.socket.on('credit_revoked', callback)
  }
}
